module.exports = __webpack_public_path__ + "static/media/authkeylogonew.26dc7082.png";